(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slich-prelaunch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('slich-launch-countdown')) {
    customElements.define('slich-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        this.updateRemaining = () => {
          const output = this.querySelector('[data-launch-remaining]');
          const raw = this.dataset.expectedDate || '';
          if (!output || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return;
          if (this.dataset.stage !== 'waiting') { this.hidden = true; return; }
          const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
          const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
          const today = Date.UTC(Number(values.year), Number(values.month)-1, Number(values.day));
          const target = Date.parse(raw + 'T00:00:00Z');
          if (!Number.isFinite(target) || new Date(target).toISOString().slice(0,10) !== raw) return;
          const days = Math.ceil((target - today) / 86400000);
          const next = days > 0 ? (this.dataset.before || '').replace('[days]', String(days)) : this.dataset.after;
          if (next && output.textContent !== next) output.textContent = next;
        };
        this.updateRemaining();
        this.timer = setInterval(this.updateRemaining, 60000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
